import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, RotateCcw, Truck, BadgeCheck } from "lucide-react";

const ITEMS = [
  { icon: BadgeCheck, label: "Certified", sub: "Optimised for solar & backup" },
  { icon: ShieldCheck, label: "12-month limited warranty", sub: "On every CORE 500", to: "/warranty" },
  { icon: RotateCcw, label: "7-day returns", sub: "Unused, in original packaging", to: "/refund-policy" },
  { icon: Truck, label: "Nigeria-wide delivery", sub: "Lagos 2–4 business days", to: "/delivery-policy" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" style={{ background: "var(--surface)", borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-5">
        {ITEMS.map((t) => {
          const I = t.icon;
          const inner = (
            <>
              <I size={22} color="var(--sun-orange)" strokeWidth={1.7} className="mt-0.5 flex-shrink-0" />
              <div>
                <div className="text-sm font-medium leading-tight" style={{ color: "var(--ink)" }}>{t.label}</div>
                <div className="text-xs mt-0.5" style={{ color: "var(--ink-soft)" }}>{t.sub}</div>
              </div>
            </>
          );
          return t.to ? (
            <Link key={t.label} to={t.to} className="flex items-start gap-3 hover:opacity-80 transition-opacity">
              {inner}
            </Link>
          ) : (
            <div key={t.label} className="flex items-start gap-3">
              {inner}
            </div>
          );
        })}
      </div>
    </section>
  );
}
